<div class="row">
  <div class="col-12 col-md-12">
    <section>
      <div class="row">
        <div class="row mb-2">
          <div class="col field-store">
            <app-custom-select [internalValue]="storeId" [labelText]="'Bodega'" [list]="listStore" [required]="true"
              (onChangeSelect)="selectedStoreId = $event"></app-custom-select>
          </div>
          <div class="col field-save d-flex align-items-end mt-2 justify-content-end">
            <app-custom-button [title]="'Seleccionar'" [label]="'Seleccionar'" [width]="'5.5rem'"
              (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>